import { alpha } from '@mui/material';
export const useRelationProfileStyles = () => {
    return {
        container: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: (theme) => '#F9F9F9',
            borderRadius: (theme) => theme.spacing(3),
            border: `1px solid ${(theme) => alpha(theme.palette.grey[500], 0.24)}`,
            overflow: 'hidden'
        },
        profileBackground: {
            position: 'relative',
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'center',
            paddingBottom: (theme) => theme.spacing(2)
        },
        avatarContainer: {
            position: 'relative',
            zIndex: 2,
            marginBottom: (theme) => theme.spacing(2)
        },
        avatar: {
            width: 80,
            height: 80,
            fontSize: '28px',
            fontWeight: 700,
            backgroundColor: (theme) => theme.palette.grey[100],
            color: (theme) => theme.palette.grey[800],
            border: `4px solid ${(theme) => theme.palette.common.white}`,
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.15)'
        },
        profileContent: {
            textAlign: 'center'
        },
        chipContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: (theme) => theme.spacing(0.5),
            marginTop: (theme) => theme.spacing(5),
            marginBottom: (theme) => theme.spacing(1)
        },
        designationChip: {
            backgroundColor: (theme) => theme.palette.primary.light,
            color: (theme) => theme.palette.primary.main,
            fontSize: '12px',
            fontWeight: 600,
            textTransform: 'uppercase',
            padding: (theme) => theme.spacing(0.5, 1.5),
            borderRadius: (theme) => theme.spacing(1)
        },
        name: {
            marginBottom: (theme) => theme.spacing(0.5)
        },
        contactIcons: {
            display: 'flex',
            justifyContent: 'center',
            marginBottom: (theme) => theme.spacing(2)
        },
        contactIcon: {
            border: 'none'
        },
        separator: {
            height: '1px',
            backgroundColor: (theme) => theme.palette.grey[200],
            margin: (theme) => theme.spacing(0, 3, 2, 3)
        },
        infoSection: {
            display: 'flex',
            justifyContent: 'space-around',
            alignItems: 'stretch',
            padding: (theme) => theme.spacing(2, 3, 2, 3),
            minHeight: '80px' // Ensure minimum height for dividers to be visible
        },
        infoItem: {
            textAlign: 'center',
            flex: 1,
            minWidth: 0,
            px: 2
        },
        infoValue: {
            fontSize: '16px',
            fontWeight: 700,
            color: (theme) => theme.palette.grey[900]
        }
    };
};
